// extracted by mini-css-extract-plugin
module.exports = {"container":"Panel_container__1D8-D","panel":"Panel_panel__rWqTC"};